import { Injectable } from "@angular/core";
import { Observable, of, throwError, from } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IDownloadExcel, IParticipants, ISessionsMetaData } from "../interface/sessions.interface";
import { get } from 'aws-amplify/api';


@Injectable()
export class SessionsService {
  public getSessionMetadata(programId: string, sessionId: string): Observable<ISessionsMetaData> {
    const op = get({
      apiName: 'portal',
      path: `programs/${programId}/sessions/${sessionId}`,
      options: {}
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      catchError(() => of([] as any)),
      map((data: ISessionsMetaData) => data as ISessionsMetaData)
    );
  }
  public getSessionParticipants(programId: string, sessionId: string): Observable<IParticipants> {
    const op = get({
      apiName: 'portal',
      path: `programs/${programId}/sessions/${sessionId}/participants`,
      options: {}
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      catchError((error) => throwError(() => error)),
      map((data: IParticipants) => data as IParticipants)
    );
  }
  public downloadSessionsReport(programId: string, sessionId: string): Observable<IDownloadExcel> {
    const op = get({
      apiName: 'portal',
      path: `programs/${programId}/sessions/${sessionId}/download`,
      options: {}
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      catchError(() => of({ data: '' } as IDownloadExcel)),
      map((data: IDownloadExcel) => data as IDownloadExcel)
    );
  }
}